var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.projectLogo)?_c('figure',{staticClass:"image"},[_c('img',{staticClass:"webinar-logo",attrs:{"src":_vm.projectLogo},on:{"error":_vm.onImageError}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }